export enum IntegrationType {
  Standalone = 'standalone',
  WebComponent = 'wc',
}

export function integrationType() {
  if (globalThis.E3D) {
    return IntegrationType.WebComponent;
  }
  return IntegrationType.Standalone;
}

export function routingEnabled() {
  return integrationType() === IntegrationType.Standalone;
}

export interface IIntegrationEvent {
  el?: HTMLElement | null;
  name: string;
  detail: Record<string, unknown>;
}

/**
 * Fire a custom event on an element that can be captured by the web component.
 * This event can be cancelled with `event.preventDefault()`.
 * If the event is cancelled, the function will return false.
 */
export function fireEvent({ el, name, detail }: IIntegrationEvent) {
  if (!el) {
    return;
  }
  const customEvent = new CustomEvent(name, {
    bubbles: true,
    composed: true,
    cancelable: true,
    detail: {
      ...detail,
    },
  });
  const canContinue = el.dispatchEvent(customEvent);
  return canContinue;
}
